<template>
  <v-card-title :class="[type, 'custom-title']">
    {{ title }}
    <slot />
  </v-card-title>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    title: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'display-2'
    }
  }
}
</script>
